import { render, staticRenderFns } from "./OrgLicenses.vue?vue&type=template&id=f2b7bcd6&"
import script from "./OrgLicenses.vue?vue&type=script&lang=js&"
export * from "./OrgLicenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports